import { css } from '@/styled-system/css';

export const accordionItemStyles = css.raw({
  display: 'flex',
  flexDirection: 'column',
  gap: 'none',
  borderWidth: 'default',
  borderStyle: 'solid',
  borderColor: 'Accordion.border.default',
  borderRadius: 'obj.default',
});
